function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as a } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import "../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import "../input-label/input-label.gator.js";
import "../help-text/help-text.gator.js";
import "../../../icon/gator/icon.gator.js";
import "../../../icon/gator/templates/add-link.js";
import "../../../icon/gator/templates/airplane.js";
import "../../../icon/gator/templates/alarm.js";
import "../../../icon/gator/templates/apartment.js";
import "../../../icon/gator/templates/arrow-around.js";
import "../../../icon/gator/templates/arrow-down.js";
import "../../../icon/gator/templates/arrow-left.js";
import "../../../icon/gator/templates/arrow-line-left.js";
import "../../../icon/gator/templates/arrow-line-right.js";
import "../../../icon/gator/templates/arrow-right.js";
import "../../../icon/gator/templates/arrow-up.js";
import "../../../icon/gator/templates/bank.js";
import "../../../icon/gator/templates/bell-disabled.js";
import "../../../icon/gator/templates/bell.js";
import "../../../icon/gator/templates/binoculars.js";
import "../../../icon/gator/templates/book.js";
import "../../../icon/gator/templates/box.js";
import "../../../icon/gator/templates/cake.js";
import "../../../icon/gator/templates/calculator.js";
import "../../../icon/gator/templates/calendar.js";
import "../../../icon/gator/templates/camera.js";
import "../../../icon/gator/templates/caret-up-down.js";
import "../../../icon/gator/templates/case.js";
import "../../../icon/gator/templates/chart-bar-horizontal.js";
import "../../../icon/gator/templates/chart-bar.js";
import "../../../icon/gator/templates/chart-donut.js";
import "../../../icon/gator/templates/chart-line.js";
import "../../../icon/gator/templates/chart-pie.js";
import "../../../icon/gator/templates/chart-rise.js";
import "../../../icon/gator/templates/chart-scatter.js";
import "../../../icon/gator/templates/chat.js";
import "../../../icon/gator/templates/check-circle.js";
import "../../../icon/gator/templates/check.js";
import "../../../icon/gator/templates/checkbox-selected.js";
import "../../../icon/gator/templates/checkbox.js";
import "../../../icon/gator/templates/checkerboard.js";
import "../../../icon/gator/templates/chevron-down.js";
import "../../../icon/gator/templates/chevron-left.js";
import "../../../icon/gator/templates/chevron-right.js";
import "../../../icon/gator/templates/chevron-up.js";
import "../../../icon/gator/templates/circle-arrow-down.js";
import "../../../icon/gator/templates/circle-arrow-left.js";
import "../../../icon/gator/templates/circle-arrow-right.js";
import "../../../icon/gator/templates/circle-arrow-up.js";
import "../../../icon/gator/templates/circle-dashed.js";
import "../../../icon/gator/templates/circle-filled.js";
import "../../../icon/gator/templates/circle.js";
import "../../../icon/gator/templates/city.js";
import "../../../icon/gator/templates/clipboard.js";
import "../../../icon/gator/templates/clock-clockwise.js";
import "../../../icon/gator/templates/clock-counter-clockwise.js";
import "../../../icon/gator/templates/clock.js";
import "../../../icon/gator/templates/collapse.js";
import "../../../icon/gator/templates/cone.js";
import "../../../icon/gator/templates/contact-info.js";
import "../../../icon/gator/templates/copy.js";
import "../../../icon/gator/templates/credit-card.js";
import "../../../icon/gator/templates/crop.js";
import "../../../icon/gator/templates/crosshairs.js";
import "../../../icon/gator/templates/currency-dollar-simple.js";
import "../../../icon/gator/templates/currency-eur.js";
import "../../../icon/gator/templates/currency-gbp.js";
import "../../../icon/gator/templates/currency-inr.js";
import "../../../icon/gator/templates/currency-jpy.js";
import "../../../icon/gator/templates/currency-krw.js";
import "../../../icon/gator/templates/currency-kzt.js";
import "../../../icon/gator/templates/currency-ngn.js";
import "../../../icon/gator/templates/currency-rub.js";
import "../../../icon/gator/templates/cursor-arrow.js";
import "../../../icon/gator/templates/cursor-hand.js";
import "../../../icon/gator/templates/cursor.js";
import "../../../icon/gator/templates/dashboard.js";
import "../../../icon/gator/templates/delete.js";
import "../../../icon/gator/templates/dna.js";
import "../../../icon/gator/templates/document-add.js";
import "../../../icon/gator/templates/document-check.js";
import "../../../icon/gator/templates/document-e-sign.js";
import "../../../icon/gator/templates/document-image.js";
import "../../../icon/gator/templates/document-pdf.js";
import "../../../icon/gator/templates/document-sign.js";
import "../../../icon/gator/templates/document-zip.js";
import "../../../icon/gator/templates/document.js";
import "../../../icon/gator/templates/dollar-bills.js";
import "../../../icon/gator/templates/dollar-house.js";
import "../../../icon/gator/templates/down-payment.js";
import "../../../icon/gator/templates/download.js";
import "../../../icon/gator/templates/drag-drop.js";
import "../../../icon/gator/templates/earth.js";
import "../../../icon/gator/templates/exclude-square.js";
import "../../../icon/gator/templates/exit-circle.js";
import "../../../icon/gator/templates/exit-left.js";
import "../../../icon/gator/templates/exit.js";
import "../../../icon/gator/templates/expand-arrows.js";
import "../../../icon/gator/templates/expand.js";
import "../../../icon/gator/templates/export.js";
import "../../../icon/gator/templates/eye-closed.js";
import "../../../icon/gator/templates/eye-crossed.js";
import "../../../icon/gator/templates/eye.js";
import "../../../icon/gator/templates/facebook-logo.js";
import "../../../icon/gator/templates/file-code.js";
import "../../../icon/gator/templates/files.js";
import "../../../icon/gator/templates/filter-funnel.js";
import "../../../icon/gator/templates/filters-2.js";
import "../../../icon/gator/templates/filters.js";
import "../../../icon/gator/templates/flags/flag-ad-andorra.js";
import "../../../icon/gator/templates/flags/flag-ae-united-arab-emirates.js";
import "../../../icon/gator/templates/flags/flag-af-afghanistan.js";
import "../../../icon/gator/templates/flags/flag-ag-antigua-and-barbuda.js";
import "../../../icon/gator/templates/flags/flag-ai-anguilla.js";
import "../../../icon/gator/templates/flags/flag-al-albania.js";
import "../../../icon/gator/templates/flags/flag-am-armenia.js";
import "../../../icon/gator/templates/flags/flag-ao-angola.js";
import "../../../icon/gator/templates/flags/flag-aq-antarctica.js";
import "../../../icon/gator/templates/flags/flag-ar-argentina.js";
import "../../../icon/gator/templates/flags/flag-as-american-smoa.js";
import "../../../icon/gator/templates/flags/flag-at-austria.js";
import "../../../icon/gator/templates/flags/flag-au-australia.js";
import "../../../icon/gator/templates/flags/flag-aw-aruba.js";
import "../../../icon/gator/templates/flags/flag-ax-aland-islands.js";
import "../../../icon/gator/templates/flags/flag-az-azerbaijan.js";
import "../../../icon/gator/templates/flags/flag-ba-bosnia-and-herzegovina.js";
import "../../../icon/gator/templates/flags/flag-bb-barbados.js";
import "../../../icon/gator/templates/flags/flag-bd-bangladesh.js";
import "../../../icon/gator/templates/flags/flag-be-belgium.js";
import "../../../icon/gator/templates/flags/flag-bf-burkina-faso.js";
import "../../../icon/gator/templates/flags/flag-bg-bulgaria.js";
import "../../../icon/gator/templates/flags/flag-bh-bahrain.js";
import "../../../icon/gator/templates/flags/flag-bi-burundi.js";
import "../../../icon/gator/templates/flags/flag-bj-benin.js";
import "../../../icon/gator/templates/flags/flag-bl-saint-barthelemy.js";
import "../../../icon/gator/templates/flags/flag-bm-bermuda.js";
import "../../../icon/gator/templates/flags/flag-bn-brunei-darussalam.js";
import "../../../icon/gator/templates/flags/flag-bo-bolivia.js";
import "../../../icon/gator/templates/flags/flag-bq-bo-bonaire.js";
import "../../../icon/gator/templates/flags/flag-bq-sa-sba.js";
import "../../../icon/gator/templates/flags/flag-bq-se-snt-eustatius.js";
import "../../../icon/gator/templates/flags/flag-br-brazil.js";
import "../../../icon/gator/templates/flags/flag-bs-bahamas.js";
import "../../../icon/gator/templates/flags/flag-bt-bhutan.js";
import "../../../icon/gator/templates/flags/flag-bv-bouvet-island.js";
import "../../../icon/gator/templates/flags/flag-bw-botswana.js";
import "../../../icon/gator/templates/flags/flag-by-belarus.js";
import "../../../icon/gator/templates/flags/flag-bz-belize.js";
import "../../../icon/gator/templates/flags/flag-ca-canada.js";
import "../../../icon/gator/templates/flags/flag-cc-cocos-keeling-islands.js";
import "../../../icon/gator/templates/flags/flag-cd-democratic-republic-of-the-congo.js";
import "../../../icon/gator/templates/flags/flag-cf-central-african-republic.js";
import "../../../icon/gator/templates/flags/flag-cg-republic-of-the-congo.js";
import "../../../icon/gator/templates/flags/flag-ch-switzerland.js";
import "../../../icon/gator/templates/flags/flag-ci-côte-divoire-ivory-coast.js";
import "../../../icon/gator/templates/flags/flag-ck-cook-islands.js";
import "../../../icon/gator/templates/flags/flag-cl-chile.js";
import "../../../icon/gator/templates/flags/flag-cm-cameroon.js";
import "../../../icon/gator/templates/flags/flag-cn-china.js";
import "../../../icon/gator/templates/flags/flag-co-colombia.js";
import "../../../icon/gator/templates/flags/flag-cr-costa-rica.js";
import "../../../icon/gator/templates/flags/flag-cu-cuba.js";
import "../../../icon/gator/templates/flags/flag-cv-cabo-verde.js";
import "../../../icon/gator/templates/flags/flag-cw-curaçao.js";
import "../../../icon/gator/templates/flags/flag-cx-christmas-island.js";
import "../../../icon/gator/templates/flags/flag-cy-cyprus.js";
import "../../../icon/gator/templates/flags/flag-cz-czech-republic.js";
import "../../../icon/gator/templates/flags/flag-de-germany.js";
import "../../../icon/gator/templates/flags/flag-dj-djibouti.js";
import "../../../icon/gator/templates/flags/flag-dk-denmark.js";
import "../../../icon/gator/templates/flags/flag-dm-dominica.js";
import "../../../icon/gator/templates/flags/flag-do-dominican-republic.js";
import "../../../icon/gator/templates/flags/flag-dz-algeria.js";
import "../../../icon/gator/templates/flags/flag-ec-ecuador.js";
import "../../../icon/gator/templates/flags/flag-ee-estonia.js";
import "../../../icon/gator/templates/flags/flag-eg-egypt.js";
import "../../../icon/gator/templates/flags/flag-eh-western-sahara.js";
import "../../../icon/gator/templates/flags/flag-er-eritrea.js";
import "../../../icon/gator/templates/flags/flag-es-sain.js";
import "../../../icon/gator/templates/flags/flag-et-ethiopia.js";
import "../../../icon/gator/templates/flags/flag-fi-finland.js";
import "../../../icon/gator/templates/flags/flag-fj-fiji.js";
import "../../../icon/gator/templates/flags/flag-fk-falkland-islands.js";
import "../../../icon/gator/templates/flags/flag-fm-federated-states-of-micronesia.js";
import "../../../icon/gator/templates/flags/flag-fo-faroe-islands.js";
import "../../../icon/gator/templates/flags/flag-fr-france.js";
import "../../../icon/gator/templates/flags/flag-ga-gabon.js";
import "../../../icon/gator/templates/flags/flag-gb-eng-england.js";
import "../../../icon/gator/templates/flags/flag-gb-nir-northern-ireland.js";
import "../../../icon/gator/templates/flags/flag-gb-sct-sotland.js";
import "../../../icon/gator/templates/flags/flag-gb-ukm-united-kingdom.js";
import "../../../icon/gator/templates/flags/flag-gb-wls-wales.js";
import "../../../icon/gator/templates/flags/flag-gd-grenada.js";
import "../../../icon/gator/templates/flags/flag-ge-georgia.js";
import "../../../icon/gator/templates/flags/flag-gf-french-guiana.js";
import "../../../icon/gator/templates/flags/flag-gg-guernsey.js";
import "../../../icon/gator/templates/flags/flag-gh-ghana.js";
import "../../../icon/gator/templates/flags/flag-gi-gibraltar.js";
import "../../../icon/gator/templates/flags/flag-gl-greenland.js";
import "../../../icon/gator/templates/flags/flag-gm-gambia.js";
import "../../../icon/gator/templates/flags/flag-gn-guinea.js";
import "../../../icon/gator/templates/flags/flag-gp-guadeloupe-2.js";
import "../../../icon/gator/templates/flags/flag-gp-guadeloupe.js";
import "../../../icon/gator/templates/flags/flag-gq-equatorial-guinea.js";
import "../../../icon/gator/templates/flags/flag-gr-greece.js";
import "../../../icon/gator/templates/flags/flag-gs-s-georgia-and-s-sandwich-islands.js";
import "../../../icon/gator/templates/flags/flag-gt-guatemala.js";
import "../../../icon/gator/templates/flags/flag-gu-guam.js";
import "../../../icon/gator/templates/flags/flag-gw-guinea-bissau.js";
import "../../../icon/gator/templates/flags/flag-gy-guyana.js";
import "../../../icon/gator/templates/flags/flag-hk-hong-kong.js";
import "../../../icon/gator/templates/flags/flag-hm-heard-and-mcdonald-islands.js";
import "../../../icon/gator/templates/flags/flag-hn-honduras.js";
import "../../../icon/gator/templates/flags/flag-hr-croatia-hrvatska.js";
import "../../../icon/gator/templates/flags/flag-ht-haiti.js";
import "../../../icon/gator/templates/flags/flag-hu-hungary.js";
import "../../../icon/gator/templates/flags/flag-id-indonesia.js";
import "../../../icon/gator/templates/flags/flag-ie-ireland.js";
import "../../../icon/gator/templates/flags/flag-il-isreal.js";
import "../../../icon/gator/templates/flags/flag-im-isle-of-man.js";
import "../../../icon/gator/templates/flags/flag-in-india.js";
import "../../../icon/gator/templates/flags/flag-io-british-indian-ocean-territory.js";
import "../../../icon/gator/templates/flags/flag-iq-iraq.js";
import "../../../icon/gator/templates/flags/flag-ir-iran.js";
import "../../../icon/gator/templates/flags/flag-is-iceland.js";
import "../../../icon/gator/templates/flags/flag-it-italy.js";
import "../../../icon/gator/templates/flags/flag-je-jersey.js";
import "../../../icon/gator/templates/flags/flag-jm-jamaica.js";
import "../../../icon/gator/templates/flags/flag-jo-jordan.js";
import "../../../icon/gator/templates/flags/flag-jp-japan.js";
import "../../../icon/gator/templates/flags/flag-ke-kenia.js";
import "../../../icon/gator/templates/flags/flag-kg-kyrgyzstan.js";
import "../../../icon/gator/templates/flags/flag-kh-cambodia.js";
import "../../../icon/gator/templates/flags/flag-ki--kiribati.js";
import "../../../icon/gator/templates/flags/flag-km-comoros.js";
import "../../../icon/gator/templates/flags/flag-kn-saint-kitts-and-nevis.js";
import "../../../icon/gator/templates/flags/flag-kp-korea-north.js";
import "../../../icon/gator/templates/flags/flag-kr-korea-south.js";
import "../../../icon/gator/templates/flags/flag-kw-kuwait.js";
import "../../../icon/gator/templates/flags/flag-ky-cayman-islands.js";
import "../../../icon/gator/templates/flags/flag-kz-kazakhstan.js";
import "../../../icon/gator/templates/flags/flag-la-laos.js";
import "../../../icon/gator/templates/flags/flag-lb-lebanon.js";
import "../../../icon/gator/templates/flags/flag-lc-saint-lucia.js";
import "../../../icon/gator/templates/flags/flag-li-liechtenstein.js";
import "../../../icon/gator/templates/flags/flag-lk-sri-lanka.js";
import "../../../icon/gator/templates/flags/flag-lr-liberia.js";
import "../../../icon/gator/templates/flags/flag-ls-lesotho.js";
import "../../../icon/gator/templates/flags/flag-lt-lithuania.js";
import "../../../icon/gator/templates/flags/flag-lu-luxembourg.js";
import "../../../icon/gator/templates/flags/flag-lv-latvia.js";
import "../../../icon/gator/templates/flags/flag-ly-libya.js";
import "../../../icon/gator/templates/flags/flag-ma-morocco.js";
import "../../../icon/gator/templates/flags/flag-mc-monaco.js";
import "../../../icon/gator/templates/flags/flag-md-moldova.js";
import "../../../icon/gator/templates/flags/flag-me-montenegro.js";
import "../../../icon/gator/templates/flags/flag-mf-saint-martin.js";
import "../../../icon/gator/templates/flags/flag-mg-madagascar.js";
import "../../../icon/gator/templates/flags/flag-mh-marshall-islands.js";
import "../../../icon/gator/templates/flags/flag-mk-north-macedonia.js";
import "../../../icon/gator/templates/flags/flag-ml-mali.js";
import "../../../icon/gator/templates/flags/flag-mm-myanmar.js";
import "../../../icon/gator/templates/flags/flag-mn-mongolia.js";
import "../../../icon/gator/templates/flags/flag-mo-macao.js";
import "../../../icon/gator/templates/flags/flag-mp-northern-mariana-islands.js";
import "../../../icon/gator/templates/flags/flag-mq-martinique-2.js";
import "../../../icon/gator/templates/flags/flag-mq-martinique.js";
import "../../../icon/gator/templates/flags/flag-mr-mauritania.js";
import "../../../icon/gator/templates/flags/flag-ms-montserrat.js";
import "../../../icon/gator/templates/flags/flag-mt-malta.js";
import "../../../icon/gator/templates/flags/flag-mu-mauritius.js";
import "../../../icon/gator/templates/flags/flag-mv-maldives.js";
import "../../../icon/gator/templates/flags/flag-mw-malawi.js";
import "../../../icon/gator/templates/flags/flag-mx-mexico.js";
import "../../../icon/gator/templates/flags/flag-my-malaysia.js";
import "../../../icon/gator/templates/flags/flag-mz-mozambique.js";
import "../../../icon/gator/templates/flags/flag-na-namibia.js";
import "../../../icon/gator/templates/flags/flag-nc-new-caledonia.js";
import "../../../icon/gator/templates/flags/flag-ne-niger.js";
import "../../../icon/gator/templates/flags/flag-nf-norfolk-island.js";
import "../../../icon/gator/templates/flags/flag-ng-nigeria.js";
import "../../../icon/gator/templates/flags/flag-ni-nicaragua.js";
import "../../../icon/gator/templates/flags/flag-nl-netherlands.js";
import "../../../icon/gator/templates/flags/flag-no-norway.js";
import "../../../icon/gator/templates/flags/flag-np-nepal.js";
import "../../../icon/gator/templates/flags/flag-nr-nauru.js";
import "../../../icon/gator/templates/flags/flag-nu-niue.js";
import "../../../icon/gator/templates/flags/flag-nz-new-zealand-aotearoa.js";
import "../../../icon/gator/templates/flags/flag-om-oman.js";
import "../../../icon/gator/templates/flags/flag-pa-panama.js";
import "../../../icon/gator/templates/flags/flag-pe-peru.js";
import "../../../icon/gator/templates/flags/flag-pf-french-polynesia.js";
import "../../../icon/gator/templates/flags/flag-pg-papua-new-guinea.js";
import "../../../icon/gator/templates/flags/flag-ph-philippines.js";
import "../../../icon/gator/templates/flags/flag-pk-pakistan.js";
import "../../../icon/gator/templates/flags/flag-pl-poland.js";
import "../../../icon/gator/templates/flags/flag-pm-saint-pierre-and-miquelon.js";
import "../../../icon/gator/templates/flags/flag-pm-st-pierre-and-miquelon.js";
import "../../../icon/gator/templates/flags/flag-pn-pitcairn-islands.js";
import "../../../icon/gator/templates/flags/flag-pr-puerto-rico.js";
import "../../../icon/gator/templates/flags/flag-ps-palestinian-territory.js";
import "../../../icon/gator/templates/flags/flag-pt-portugal.js";
import "../../../icon/gator/templates/flags/flag-pw-palau.js";
import "../../../icon/gator/templates/flags/flag-py-paraguay.js";
import "../../../icon/gator/templates/flags/flag-qa-qatar.js";
import "../../../icon/gator/templates/flags/flag-re-reunion.js";
import "../../../icon/gator/templates/flags/flag-ro-romania.js";
import "../../../icon/gator/templates/flags/flag-rs-srbia.js";
import "../../../icon/gator/templates/flags/flag-ru-russian-federation.js";
import "../../../icon/gator/templates/flags/flag-rw-rwanda.js";
import "../../../icon/gator/templates/flags/flag-sa-sudi-arabia.js";
import "../../../icon/gator/templates/flags/flag-sb-slomon-islands.js";
import "../../../icon/gator/templates/flags/flag-sc-sychelles.js";
import "../../../icon/gator/templates/flags/flag-sd-sdan.js";
import "../../../icon/gator/templates/flags/flag-se-seden.js";
import "../../../icon/gator/templates/flags/flag-sg-sngapore.js";
import "../../../icon/gator/templates/flags/flag-sh-sint-helena.js";
import "../../../icon/gator/templates/flags/flag-si-sovenia.js";
import "../../../icon/gator/templates/flags/flag-sj-salbard-and-jan-mayen.js";
import "../../../icon/gator/templates/flags/flag-sk-sovakia.js";
import "../../../icon/gator/templates/flags/flag-sl-serra-leone.js";
import "../../../icon/gator/templates/flags/flag-sm-sn-marino.js";
import "../../../icon/gator/templates/flags/flag-sn-snegal.js";
import "../../../icon/gator/templates/flags/flag-so-smalia.js";
import "../../../icon/gator/templates/flags/flag-sr-sriname.js";
import "../../../icon/gator/templates/flags/flag-ss-south-sudan.js";
import "../../../icon/gator/templates/flags/flag-st-so-tome-and-principe.js";
import "../../../icon/gator/templates/flags/flag-sv-el-slvador.js";
import "../../../icon/gator/templates/flags/flag-sx-snt-maarten.js";
import "../../../icon/gator/templates/flags/flag-sy-sria.js";
import "../../../icon/gator/templates/flags/flag-sz-saziland.js";
import "../../../icon/gator/templates/flags/flag-tc-turks-and-caicos-islands.js";
import "../../../icon/gator/templates/flags/flag-td-chad.js";
import "../../../icon/gator/templates/flags/flag-tf-french-southern-and-antarctic-lands.js";
import "../../../icon/gator/templates/flags/flag-tg-togo.js";
import "../../../icon/gator/templates/flags/flag-th-thailand.js";
import "../../../icon/gator/templates/flags/flag-tj-tajikistan.js";
import "../../../icon/gator/templates/flags/flag-tk-tokelau.js";
import "../../../icon/gator/templates/flags/flag-tl-timor-leste.js";
import "../../../icon/gator/templates/flags/flag-tm-turkmenistan.js";
import "../../../icon/gator/templates/flags/flag-tn-tunisia.js";
import "../../../icon/gator/templates/flags/flag-to-tonga.js";
import "../../../icon/gator/templates/flags/flag-tr-turkey.js";
import "../../../icon/gator/templates/flags/flag-tt-trinidad-and-tobago.js";
import "../../../icon/gator/templates/flags/flag-tv-tuvalu.js";
import "../../../icon/gator/templates/flags/flag-tw-taiwan.js";
import "../../../icon/gator/templates/flags/flag-tz-tanzania.js";
import "../../../icon/gator/templates/flags/flag-ua-ukraine.js";
import "../../../icon/gator/templates/flags/flag-ug-uganda.js";
import "../../../icon/gator/templates/flags/flag-um-united-states-minor-outlying-islands.js";
import "../../../icon/gator/templates/flags/flag-us-united-states.js";
import "../../../icon/gator/templates/flags/flag-uy-uruguay.js";
import "../../../icon/gator/templates/flags/flag-uz-uzbekistan.js";
import "../../../icon/gator/templates/flags/flag-va-vatican-city-state.js";
import "../../../icon/gator/templates/flags/flag-vc-saint-vincent-and-the-grenadines.js";
import "../../../icon/gator/templates/flags/flag-ve-venezuela.js";
import "../../../icon/gator/templates/flags/flag-vg-virgin-islands-british.js";
import "../../../icon/gator/templates/flags/flag-vi-virgin-islands-us.js";
import "../../../icon/gator/templates/flags/flag-vn-vietnam.js";
import "../../../icon/gator/templates/flags/flag-vu-vanuatu.js";
import "../../../icon/gator/templates/flags/flag-wf-wallis-and-futuna.js";
import "../../../icon/gator/templates/flags/flag-ws-smoa.js";
import "../../../icon/gator/templates/flags/flag-ye-yemen.js";
import "../../../icon/gator/templates/flags/flag-yt-unf-mayotte.js";
import "../../../icon/gator/templates/flags/flag-za-south-africa.js";
import "../../../icon/gator/templates/flags/flag-zm-zambia.js";
import "../../../icon/gator/templates/flags/flag-zw-zimbabwe.js";
import "../../../icon/gator/templates/flame.js";
import "../../../icon/gator/templates/flash-off.js";
import "../../../icon/gator/templates/flash-on.js";
import "../../../icon/gator/templates/folder.js";
import "../../../icon/gator/templates/gauge.js";
import "../../../icon/gator/templates/grid-four.js";
import "../../../icon/gator/templates/grid-nine.js";
import "../../../icon/gator/templates/hammer.js";
import "../../../icon/gator/templates/hand-pointing.js";
import "../../../icon/gator/templates/heart.js";
import "../../../icon/gator/templates/home-door.js";
import "../../../icon/gator/templates/home-finance-arrow.js";
import "../../../icon/gator/templates/home-finance.js";
import "../../../icon/gator/templates/home-search.js";
import "../../../icon/gator/templates/house-simple.js";
import "../../../icon/gator/templates/house.js";
import "../../../icon/gator/templates/inbox.js";
import "../../../icon/gator/templates/info.js";
import "../../../icon/gator/templates/instagram-logo.js";
import "../../../icon/gator/templates/interest-rate.js";
import "../../../icon/gator/templates/invoice.js";
import "../../../icon/gator/templates/kanban.js";
import "../../../icon/gator/templates/label.js";
import "../../../icon/gator/templates/laptop.js";
import "../../../icon/gator/templates/layout.js";
import "../../../icon/gator/templates/lightbulb-filament.js";
import "../../../icon/gator/templates/lightbulb.js";
import "../../../icon/gator/templates/link.js";
import "../../../icon/gator/templates/linkedin-logo.js";
import "../../../icon/gator/templates/list-star.js";
import "../../../icon/gator/templates/list.js";
import "../../../icon/gator/templates/loading-spinner-gif.js";
import "../../../icon/gator/templates/loading.js";
import "../../../icon/gator/templates/lock.js";
import "../../../icon/gator/templates/magic-wand.js";
import "../../../icon/gator/templates/mail-open.js";
import "../../../icon/gator/templates/mail.js";
import "../../../icon/gator/templates/mailbox.js";
import "../../../icon/gator/templates/map.js";
import "../../../icon/gator/templates/menu-hamburger.js";
import "../../../icon/gator/templates/microsoft-excel-logo.js";
import "../../../icon/gator/templates/microsoft-outlook-logo.js";
import "../../../icon/gator/templates/microsoft-powerpoint-logo.js";
import "../../../icon/gator/templates/microsoft-teams-logo.js";
import "../../../icon/gator/templates/microsoft-word-logo.js";
import "../../../icon/gator/templates/minus-circle.js";
import "../../../icon/gator/templates/minus-square.js";
import "../../../icon/gator/templates/minus.js";
import "../../../icon/gator/templates/mobile-phone-2.js";
import "../../../icon/gator/templates/monitor.js";
import "../../../icon/gator/templates/move-doc.js";
import "../../../icon/gator/templates/move.js";
import "../../../icon/gator/templates/music.js";
import "../../../icon/gator/templates/number-1.js";
import "../../../icon/gator/templates/number-2.js";
import "../../../icon/gator/templates/number-3.js";
import "../../../icon/gator/templates/overflow-menu.js";
import "../../../icon/gator/templates/paper-airplane.js";
import "../../../icon/gator/templates/paperclip.js";
import "../../../icon/gator/templates/payments/payment-amazon-pay.js";
import "../../../icon/gator/templates/payments/payment-amex.js";
import "../../../icon/gator/templates/payments/payment-apple-pay.js";
import "../../../icon/gator/templates/payments/payment-discover.js";
import "../../../icon/gator/templates/payments/payment-google-pay.js";
import "../../../icon/gator/templates/payments/payment-mastercard.js";
import "../../../icon/gator/templates/payments/payment-visa.js";
import "../../../icon/gator/templates/pen.js";
import "../../../icon/gator/templates/pencil-paper.js";
import "../../../icon/gator/templates/pencil.js";
import "../../../icon/gator/templates/people-multiple.js";
import "../../../icon/gator/templates/people-share.js";
import "../../../icon/gator/templates/percent.js";
import "../../../icon/gator/templates/person-add.js";
import "../../../icon/gator/templates/person-check.js";
import "../../../icon/gator/templates/person-lock.js";
import "../../../icon/gator/templates/person.js";
import "../../../icon/gator/templates/phone-alert.js";
import "../../../icon/gator/templates/phone-mobile.js";
import "../../../icon/gator/templates/phone.js";
import "../../../icon/gator/templates/picture.js";
import "../../../icon/gator/templates/pin.js";
import "../../../icon/gator/templates/pinterest-logo.js";
import "../../../icon/gator/templates/plus-circle.js";
import "../../../icon/gator/templates/plus.js";
import "../../../icon/gator/templates/printer.js";
import "../../../icon/gator/templates/question-chat-bubble.js";
import "../../../icon/gator/templates/question-circle.js";
import "../../../icon/gator/templates/question-mark.js";
import "../../../icon/gator/templates/radio-selected.js";
import "../../../icon/gator/templates/radio.js";
import "../../../icon/gator/templates/receipt.js";
import "../../../icon/gator/templates/restricted.js";
import "../../../icon/gator/templates/sandals.js";
import "../../../icon/gator/templates/save.js";
import "../../../icon/gator/templates/screen.js";
import "../../../icon/gator/templates/search.js";
import "../../../icon/gator/templates/selection.js";
import "../../../icon/gator/templates/settings.js";
import "../../../icon/gator/templates/share-1.js";
import "../../../icon/gator/templates/share-2.js";
import "../../../icon/gator/templates/shield-lock.js";
import "../../../icon/gator/templates/shield-warning.js";
import "../../../icon/gator/templates/sidebar-simple.js";
import "../../../icon/gator/templates/sidebar.js";
import "../../../icon/gator/templates/smart-home.js";
import "../../../icon/gator/templates/sort-arrow-solid-down.js";
import "../../../icon/gator/templates/sort-arrow-solid-left.js";
import "../../../icon/gator/templates/sort-arrow-solid-right.js";
import "../../../icon/gator/templates/sort-arrow-solid-up-down.js";
import "../../../icon/gator/templates/sort-arrow-solid-up.js";
import "../../../icon/gator/templates/sort-reverse-variant.js";
import "../../../icon/gator/templates/sort-variant.js";
import "../../../icon/gator/templates/sparkle-filled.js";
import "../../../icon/gator/templates/sparkle.js";
import "../../../icon/gator/templates/speech-bubble.js";
import "../../../icon/gator/templates/square-split-horizontal.js";
import "../../../icon/gator/templates/square-split-vertical.js";
import "../../../icon/gator/templates/square.js";
import "../../../icon/gator/templates/stack.js";
import "../../../icon/gator/templates/stamp.js";
import "../../../icon/gator/templates/star-four-filled.js";
import "../../../icon/gator/templates/star-four.js";
import "../../../icon/gator/templates/star.js";
import "../../../icon/gator/templates/stopwatch.js";
import "../../../icon/gator/templates/sun.js";
import "../../../icon/gator/templates/sync.js";
import "../../../icon/gator/templates/tab-arrows.js";
import "../../../icon/gator/templates/table.js";
import "../../../icon/gator/templates/target.js";
import "../../../icon/gator/templates/text-aa.js";
import "../../../icon/gator/templates/thumbs-down.js";
import "../../../icon/gator/templates/thumbs-up.js";
import "../../../icon/gator/templates/tools.js";
import "../../../icon/gator/templates/touch-id.js";
import "../../../icon/gator/templates/trash.js";
import "../../../icon/gator/templates/trend-up.js";
import "../../../icon/gator/templates/twitter-logo.js";
import "../../../icon/gator/templates/unlink.js";
import "../../../icon/gator/templates/unlock.js";
import "../../../icon/gator/templates/upload.js";
import "../../../icon/gator/templates/video.js";
import "../../../icon/gator/templates/waffle.js";
import "../../../icon/gator/templates/warning-circle.js";
import "../../../icon/gator/templates/warning-diamond.js";
import "../../../icon/gator/templates/warning-octagon.js";
import "../../../icon/gator/templates/warning.js";
import "../../../icon/gator/templates/wet-sign.js";
import "../../../icon/gator/templates/wifi-off.js";
import "../../../icon/gator/templates/wifi.js";
import "../../../icon/gator/templates/x-logo.js";
import "../../../icon/gator/templates/yelp-logo.js";
import "../../../icon/gator/templates/youtube-logo.js";
import "../../../icon/gator/templates/zillow-logo.js";
import { customElement as f } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as s } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import { state as e } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/state.js";
import { createRef as d, ref as c } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/ref.js";
import { NgcInputBase as y } from "../../base/input-base.gator.js";
import { ifDefined as l } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/if-defined.js";
import { live as v } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/live.js";
import { classMap as $ } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/class-map.js";
var b = Object.defineProperty,
  g = Object.getOwnPropertyDescriptor,
  r = function r(t, o, p, n) {
    for (var m = n > 1 ? void 0 : n ? g(o, p) : o, u = t.length - 1, h; u >= 0; u--) (h = t[u]) && (m = (n ? h(o, p, m) : h(m)) || m);
    return n && m && b(o, p, m), m;
  };
var i = /*#__PURE__*/function (_y) {
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _callSuper(this, i, arguments), _this.inputRef = d(), _this.controlRef = d(), _this.for = "", _this._inputMode = "text";
    return _this;
  }
  _inherits(i, _y);
  return _createClass(i, [{
    key: "render",
    value: function render() {
      return a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div class=\"gator-form-element\">\n                <slot name=\"label\">\n                    ", "\n                </slot>\n                <div ", " class=\"", "\">\n                    <div class=\"gator-input-container\">\n                        ", "\n                        <input\n                            ", "\n                            type=\"", "\"\n                            id=\"", "-input\"\n                            data-testid=", "-input\n                            .placeholder=\"", "\"\n                            .required=\"", "\"\n                            .disabled=\"", "\"\n                            ?readonly=\"", "\"\n                            class=\"gator-input\"\n                            aria-invalid=\"", "\"\n                            aria-required=\"", "\"\n                            aria-labelledby=\"", "\"\n                            aria-describedby=\"", "\"\n                            .value=\"", "\"\n                            maxlength=\"", "\"\n                            .min=\"", "\"\n                            .max=\"", "\"\n                            .step=\"", "\"\n                            inputmode=\"", "\"\n                            .pattern=\"", "\"\n                            @input=\"", "\"\n                            @change=\"", "\"\n                            @click=\"", "\"\n                            @focusin=\"", "\"\n                            @focusout=\"", "\"\n                            @invalid=\"", "\"\n                            @keydown=\"", "\"\n                            @keyup=\"", "\"\n                            @wheel=\"", "\"\n                        />\n                        <slot name=\"end-slot\">\n                            ", "\n                        </slot>\n                    </div>\n                </div>\n\n                ", "\n            </div>\n        "])), this.label && !this.iconAsLabel ? this.labelMarkup : null, c(this.controlRef), $(this.controlClasses), this.shouldHaveStartMarkup ? a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                                <div class=\"gator-input-start\">\n                                    ", "\n                                </div>"])), this.startIconMarkup || this._startIconAsText) : null, c(this.inputRef), this.type, this.id, l(this.dataTestid), v(this._placeholder), this.required, this.disabled, this.readonly, this.isAriaInvalid, this.required, this.ariaLabelledbyValue, this.ariaDescribedby, v(this._value), l(this._maxLength), this.min, this.max, l(this.step), this._inputMode, l(this.pattern), this.handleInputEvent, this.handleChange, this.handleClick, this.handleInputFocusIn, this.handleInputFocusOut, this.handleNativeInputValidation, this.handleKeydown, this.handleKeyup, this.handleWheel, this.shouldHaveEndMarkup ? a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                                    <div class=\"gator-input-end\">\n                                        ", "\n                                        ", "\n                                    </div>"])), this.passwordVisibilityMarkup, this.endIconMarkup) : null, this.bottomText);
    }
  }, {
    key: "updated",
    value: function updated(t) {
      t.has("value") && (this._value = this.value), t.has("placeholder") && (this._placeholder = this.placeholder), t.has("ariaLabelledByElements") && this.ariaLabelledByElements && (this.inputRef.value.ariaLabelledByElements = this.ariaLabelledByElements);
    }
  }, {
    key: "displayedErrorText",
    get: function get() {
      return this.errorText || this._internalValidationError || this._nativeInputError;
    }
  }, {
    key: "isAriaInvalid",
    get: function get() {
      return this.displayedErrorText ? "true" : "false";
    }
  }, {
    key: "passwordVisibilityMarkup",
    get: function get() {
      return this.endIconMarkup || this.type !== "password" ? null : a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<ngc-icon name=\"eye-crossed\" @click=\"", "\"></ngc-icon>"])), this.togglePasswordVisibility);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _superPropGet(i, "connectedCallback", this, 3)([]), this._value = this.value, this._maxLength = this.maxLength, this._placeholder = this.placeholder;
    }
  }, {
    key: "handleNativeInputValidation",
    value: function handleNativeInputValidation(t) {
      this.inputRef.value && (this._nativeInputError = this.inputRef.value.validationMessage), t.preventDefault();
    }
  }, {
    key: "handleWheel",
    value: function handleWheel() {
      var t;
      if (this.type == "number") {
        (t = this.inputRef.value) == null || t.blur();
        return;
      }
    }
  }, {
    key: "handleInputEvent",
    value: function handleInputEvent(t) {
      t.preventDefault(), t.stopPropagation();
      var o = t.target,
        p = new CustomEvent("input", {
          bubbles: !0,
          composed: !0,
          detail: {
            value: o.value
          }
        });
      this._value = o.value, this.dispatchEvent(p);
    }
  }, {
    key: "handleChange",
    value: function handleChange(t) {
      t.preventDefault(), t.stopPropagation();
      var o = t.target,
        p = new CustomEvent("change", {
          composed: !0,
          bubbles: !0,
          detail: {
            value: o.value
          }
        });
      this._value = o.value, this.dispatchEvent(p);
    }
  }, {
    key: "togglePasswordVisibility",
    value: function togglePasswordVisibility() {
      var t = this.inputRef.value;
      t && (t.type = t.type === "password" ? "text" : "password");
    }
  }, {
    key: "handleInputFocusOut",
    value: function handleInputFocusOut() {
      var t;
      _superPropGet(i, "handleInputFocusOut", this, 3)([]), (t = this.inputRef.value) != null && t.checkValidity() && !this.readonly && (this._nativeInputError = "");
    }
  }, {
    key: "errorTextMarkup",
    get: function get() {
      return this.displayedErrorText ? a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                <ngc-help-text\n                    icon\n                    error\n                    data-testid=", "\n                    id=", "\n                >\n                    ", "\n                </ngc-help-text>\n            "])), this.errorMessageDataTestid, this.errorTextId, this.displayedErrorText) : null;
    }
  }]);
}(y);
i.shadowRootOptions = _objectSpread(_objectSpread({}, y.shadowRootOptions), {}, {
  delegatesFocus: !0
});
r([s()], i.prototype, "for", 2);
r([s({
  type: Number
})], i.prototype, "min", 2);
r([s({
  type: Number
})], i.prototype, "max", 2);
r([s({
  type: Number
})], i.prototype, "step", 2);
r([s({
  type: String
})], i.prototype, "pattern", 2);
r([e()], i.prototype, "_value", 2);
r([e()], i.prototype, "_inputMode", 2);
r([e()], i.prototype, "_placeholder", 2);
r([e()], i.prototype, "_maxLength", 2);
r([e()], i.prototype, "_errorText", 2);
r([e()], i.prototype, "_internalValidationError", 2);
r([e()], i.prototype, "_nativeInputError", 2);
i = r([f("ngc-input-text")], i);
export { i as NgcInputText };